import React from "react";
import { useSelector } from "react-redux";
import { profile } from "../../../assets";
import { getUserName } from "../../../redux/slice/userSlice";

const ProfileContainer = () => {
  const name = useSelector(getUserName);
  return (
    <div className="flex flex-row items-center gap-3 max-w-[180px]">
      <img
        src={profile}
        alt=""
        className="sm:w-[50px] sm:h-[50px] w-[45px] h-[45px]"
      />
      <span className="sm:block hidden text-textSecondary overflow-hidden overflow-ellipsis w-[100px] whitespace-nowrap">
        {name}
      </span>
    </div>
  );
};

export default ProfileContainer;
